export default "__VITE_ASSET__p9XQ8l9Z__"